import { RootState } from 'redux/store';
import { Group } from './reducer';

export const selectHasGroup = (...allowedGroups: Group[]) => (state: RootState) => {
  const { userData } = state.auth.signIn;
  return userData?.groups?.some(group => allowedGroups.includes(group));
};
